import SecondComponent from './SecondComponent';

export default SecondComponent;
